export const uk = {
    'high-priority': 'Высокий',
    'low-priority': 'Низкий',
    'medium-priority': 'Средний',
    'replace-validation-error-invalid-characters':
        'Минус-слова нужно указывать через пробел, не используя знаки: «-»  и «,».',
    'status-active': 'Активна',
    'status-archived': 'В архиве',
    'status-draft': 'Черновик',
    'status-reject-by-moderator': 'Отклонена на модерации',
    'status-stopped': 'Остановлена'
};
